module.exports = __webpack_public_path__ + "assets/img/21-l.22fec6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/21-l.jpg
// module id = t0v+
// module chunks = 0